export enum ApiEndpoint {
  core,
  client,
}
